import dayjs from 'dayjs';
import React from 'react';
import { useLocation } from 'react-router-dom';

export class DateCalcutale {
  static yearCalculate(year: number, age: number) {
    const cal = year - age;
    return String(`01/01/${cal}`);
  }
}

export class AgeCalcutale {
  static ageCalculate(date: string) {
    return String(dayjs().diff(dayjs(date), 'year'));
  }
}

const headers = {
  Accept: 'application/json',
  'Content-type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('access')}`,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

const ApiHeader = {
  'Content-type': 'application/json',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export { headers, ApiHeader };

export function checkReturnValue(value: any) {
  if (value == null) {
    // The value is either undefined or null
    // Handle the case accordingly
    return 'Not Set';
  } else if (value === '') {
    // The value is either empty
    // Handle the case accordingly
    return 'Not Set';
  } else {
    // The value is not undefined or null
    // Proceed with other logic
    return value;
  }
}

export function formatTimeString(timeString: any) {
  // Use a regular expression to insert a space between hours and minutes
  return timeString.replace(/(\d+h)(\d+m)/, '$1 $2');
}

export function formatTimeValue(time: any) {
  const startDateString = time;

  // Create a Date object
  const date = new Date(startDateString);

  // Extract hours and minutes
  let hours = date.getHours();
  const minutes = date.getMinutes();

  // Determine AM/PM
  const ampm = hours >= 12 ? 'PM' : 'AM';

  // Convert hours from 24-hour to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  // Format minutes to always be two digits
  const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

  // Combine into the final formatted time
  return `${hours}-${formattedMinutes} ${ampm}`;
}

export function formatTimeRange(timeRange: any) {
  return timeRange.replace(/(\d{1,2})-(\d{2})/g, '$1:$2');
}

export function UseQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
